module.exports = __webpack_public_path__ + "img/logo-dark.8f4c2c54.png";